import { Card, Row, Col, Button, Spinner } from 'react-bootstrap';
import { Award, TrendingUp, TrendingDown, UserCog } from 'lucide-react';
import type { CustomerBalance } from '../../../../infrastructure/LoyaltyClient';

interface CustomerBalanceCardProps {
  balance: CustomerBalance;
  isLoading: boolean;
  onEarnPoints: () => void;
  onRedeemPoints: () => void;
  onUpdateTier: () => void;
}

export const CustomerBalanceCard = ({
  balance,
  isLoading,
  onEarnPoints,
  onRedeemPoints,
  onUpdateTier,
}: CustomerBalanceCardProps) => {
  if (isLoading) {
    return (
      <Card className="mb-4">
        <Card.Body className="text-center">
          <Spinner animation="border" />
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="mb-4">
      <Card.Body>
        <Row>
          <Col md={8}>
            <h3 className="mb-3">Customer Balance</h3>
            <Row>
              <Col sm={6}>
                <div className="mb-3">
                  <small className="text-muted">Customer ID</small>
                  <h5>{balance.customerId}</h5>
                </div>
              </Col>
              <Col sm={6}>
                <div className="mb-3">
                  <small className="text-muted">Current Tier</small>
                  <h5>
                    <Award size={20} className="me-2" />
                    {balance.tier}
                  </h5>
                </div>
              </Col>
              <Col sm={4}>
                <div className="mb-3">
                  <small className="text-muted">Available Points</small>
                  <h5 className="text-primary">{balance.availablePoints?.toLocaleString() || '0'}</h5>
                </div>
              </Col>
              <Col sm={4}>
                <div className="mb-3">
                  <small className="text-muted">Total Earned</small>
                  <h5 className="text-success">{balance.earned?.toLocaleString() || '0'}</h5>
                </div>
              </Col>
              <Col sm={4}>
                <div className="mb-3">
                  <small className="text-muted">Total Redeemed</small>
                  <h5 className="text-warning">{balance.redeemed?.toLocaleString() || '0'}</h5>
                </div>
              </Col>
            </Row>
          </Col>
          <Col md={4} className="d-flex flex-column justify-content-center gap-2">
            <Button variant="success" onClick={onEarnPoints} className="w-100">
              <TrendingUp size={16} className="me-2" />
              Earn Points
            </Button>
            <Button variant="warning" onClick={onRedeemPoints} className="w-100">
              <TrendingDown size={16} className="me-2" />
              Redeem Points
            </Button>
            <Button variant="info" onClick={onUpdateTier} className="w-100">
              <UserCog size={16} className="me-2" />
              Update Tier
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
